"use strict";
// packages/types/src/accounts.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxType = exports.BankAccountType = exports.AccountStatus = exports.AccountClass = exports.AccountType = void 0;
var AccountType;
(function (AccountType) {
    AccountType["ASSET"] = "ASSET";
    AccountType["EQUITY"] = "EQUITY";
    AccountType["EXPENSE"] = "EXPENSE";
    AccountType["LIABILITY"] = "LIABILITY";
    AccountType["REVENUE"] = "REVENUE";
    AccountType["BANK"] = "BANK";
    AccountType["DEPRECIATION"] = "DEPRECIATION";
})(AccountType || (exports.AccountType = AccountType = {}));
var AccountClass;
(function (AccountClass) {
    AccountClass["ASSET"] = "ASSET";
    AccountClass["EQUITY"] = "EQUITY";
    AccountClass["EXPENSE"] = "EXPENSE";
    AccountClass["LIABILITY"] = "LIABILITY";
    AccountClass["REVENUE"] = "REVENUE";
})(AccountClass || (exports.AccountClass = AccountClass = {}));
var AccountStatus;
(function (AccountStatus) {
    AccountStatus["ACTIVE"] = "ACTIVE";
    AccountStatus["ARCHIVED"] = "ARCHIVED";
})(AccountStatus || (exports.AccountStatus = AccountStatus = {}));
var BankAccountType;
(function (BankAccountType) {
    BankAccountType["BANK"] = "BANK";
    BankAccountType["CREDITCARD"] = "CREDITCARD";
    BankAccountType["PAYPAL"] = "PAYPAL";
})(BankAccountType || (exports.BankAccountType = BankAccountType = {}));
var TaxType;
(function (TaxType) {
    TaxType["INPUT"] = "INPUT";
    TaxType["OUTPUT"] = "OUTPUT";
    TaxType["EXEMPTEXPENSES"] = "EXEMPTEXPENSES";
    TaxType["EXEMPTOUTPUT"] = "EXEMPTOUTPUT";
    TaxType["BASEXCLUDED"] = "BASEXCLUDED";
    TaxType["GSTONIMPORTS"] = "GSTONIMPORTS";
})(TaxType || (exports.TaxType = TaxType = {}));
